import { useNavigate } from '@tanstack/react-router'
import React from 'react'

import {
  ForbiddenError,
  MembershipLimitError,
  MissingAccountError,
  NotFoundError,
  ProjectExpiredError,
  UnauthorizedError,
} from '@/modules/errors'
import { Forbidden } from './Forbidden'
import { MembershipLimitReached } from './MembershipLimitReached'
import { NotFound } from './NotFound'
import { ProjectExpired } from './ProjectExpired'
import { Unauthorized } from './Unauthorized'
import { UnexpectedError } from './UnexpecteError'

interface AppErrorProps extends React.HTMLAttributes<HTMLDivElement> {
  error?: Error | null
  reset?: () => void
}

const AppError = React.forwardRef<HTMLDivElement, AppErrorProps>(
  ({ className, error, reset, ...props }, ref) => {
    const navigate = useNavigate()

    if (error instanceof MissingAccountError) {
      navigate({ to: '/create-account' })
      return
    }

    if (error instanceof NotFoundError) {
      return <NotFound error={error} />
    }

    if (error instanceof ForbiddenError) {
      return <Forbidden />
    }

    if (error instanceof MembershipLimitError) {
      return <MembershipLimitReached ref={ref} />
    }

    if (error instanceof ProjectExpiredError) {
      return <ProjectExpired ref={ref} />
    }

    if (error instanceof UnauthorizedError) {
      return <Unauthorized ref={ref} />
    }

    return <UnexpectedError error={error} reset={reset} {...props} ref={ref} />
  },
)

AppError.displayName = 'AppError'

export { AppError }
